
import Vue from "vue";

export default Vue.extend({
	props: {
		id: String
	},
	computed: {
		src() {
			return "https://player.vimeo.com/video/" + this.id + "?h=8119619cd8&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
		}
	},

	i18nEx: {
		componentPrefix: "components.browse"
	}
});
